import React, { useEffect, useState } from "react";
import { Steps, ConfigProvider } from "antd";
import { TbPrompt, TbCode } from "react-icons/tb";
import { SlGlobe } from "react-icons/sl";

const Intro = () => {
    const [activeStep, setActiveStep] = useState(-1);

    useEffect(() => {
        const animateSteps = async () => {
            setActiveStep(-1);
            await new Promise((resolve) => setTimeout(resolve, 500));
            setActiveStep(0);
            await new Promise((resolve) => setTimeout(resolve, 800));
            setActiveStep(1);
            await new Promise((resolve) => setTimeout(resolve, 800));
            setActiveStep(2);
        };

        animateSteps();

        const intervalId = setInterval(animateSteps, 5000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="w-full h-full flex flex-col items-center justify center">
            <div className="w-full text-center flex flex-col items-center justify-center">
                <h1 className="w-full text-gray-700 flex flex-col justify-center items-center">
                    <span className="flex flex-row items-center my-[5px]">
                        <span
                            style={{
                                fontSize: "45px",
                                lineHeight: "45px",
                            }}
                        >
                            Build Custom
                        </span>
                    </span>

                    <span className="flex flex-row items-center">
                        <span
                            style={{
                                fontSize: "50px",
                                lineHeight: "50px",
                            }}
                            className="text-[var(--goat-theme-green-1)] font-bold"
                        >
                            Web Scrapers
                        </span>
                    </span>
                    <span
                        className="text-gray-600 mt-3"
                        style={{
                            fontSize: "16px",
                        }}
                    >
                        with No-code. No-BS. Definitely No BS4.
                    </span>
                </h1>
            </div>
            <div className="mt-[10px] mb-[8px] text-sm w-full flex flex-col items-center justify-center">
                <p className="text-center text-gray-700"></p>
            </div>
            <div className="w-full flex flex-col items-center justify-center pt-4 pb-1">
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: "var(--goat-theme-green-1)",
                        },
                    }}
                >
                    <Steps
                        items={[
                            {
                                title: (
                                    <span
                                        className={`transition-opacity flex flex-row items-center duration-500 ${
                                            activeStep >= 0
                                                ? "opacity-100"
                                                : "opacity-40"
                                        }`}
                                    >
                                        Write Prompt
                                    </span>
                                ),
                                status: "finish",
                                icon: (
                                    <TbPrompt
                                        size={28}
                                        className={`mt-[2px] text-[var(--goat-theme-green-1)] transition-opacity duration-500 ${
                                            activeStep >= 0
                                                ? "opacity-100"
                                                : "opacity-40"
                                        }`}
                                    />
                                ),
                            },
                            {
                                title: (
                                    <span
                                        className={`transition-opacity duration-500 ${
                                            activeStep >= 1
                                                ? "opacity-100"
                                                : "opacity-40"
                                        }`}
                                    >
                                        Scan Webpages
                                    </span>
                                ),
                                status: "finish",
                                icon: (
                                    <SlGlobe
                                        size={20}
                                        className={`mt-[5px] text-[var(--goat-theme-green-1)] transition-opacity duration-500 ${
                                            activeStep >= 1
                                                ? "opacity-100"
                                                : "opacity-40"
                                        }`}
                                    />
                                ),
                            },
                            {
                                title: (
                                    <span
                                        className={`transition-opacity duration-500 ${
                                            activeStep >= 2
                                                ? "opacity-100"
                                                : "opacity-40"
                                        }`}
                                    >
                                        Generate Scraper
                                    </span>
                                ),
                                status: "process",
                                icon: (
                                    <TbCode
                                        className={`mt-[5px] text-[var(--goat-theme-green-1)] transition-opacity duration-500 ${
                                            activeStep >= 2
                                                ? "opacity-100"
                                                : "opacity-40"
                                        }`}
                                    />
                                ),
                            },
                        ]}
                    />
                </ConfigProvider>
            </div>
        </div>
    );
};

export default Intro;
